(function dbaModuleDefinition() {
    'use strict';

    angular.module('Dba', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList', 'UnitOrgComboControl'
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function dbaConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('dba-detail', {
                    url: "/dba/Detail/{key}/{id}",
                    templateUrl: config.resourceUrl('/views/dba/dba-detail.html'),
                    controller: 'dbaDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('VIEW INDEX').or('EDIT AND DELETE INDEX')
                });
            }])
})();